import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getUserInfo, updateUserInfo } from '@/api/user'

/**
 * 用户状态管理
 * 功能：管理用户登录状态、用户信息等
 */
export const useUserStore = defineStore(
  'user',
  () => {
    // 状态
    const userInfo = ref<Myself | null>(null)
    const wxLoginInfo = ref<WxLoginInfo_User | null>(null)
    // 注册步骤
    const userRegisterStep = ref<number>(0)
    const isLoggedIn = ref(false)

    /**
     * 获取用户信息
     * @returns Promise<UserInfo>
     */
    const getUserInfoAction = async (): Promise<Myself> => {
      try {
        const res = await getUserInfo()
        userInfo.value = res
        userRegisterStep.value = res.parentInfo.registerStep || 0
        console.log(res, userRegisterStep.value, 'userRegisterStep')
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    }

    /**
     * 更新用户信息
     * @param data 用户信息
     * @returns Promise<UserInfo>
     */
    const updateUserInfoAction = async (data: Partial<Myself>): Promise<Myself> => {
      try {
        const res = await updateUserInfo(data)
        userInfo.value = res
        return Promise.resolve(res)
      } catch (error) {
        return Promise.reject(error)
      }
    }

    /**
     * 设置用户信息（用于微信登录后）
     * @param data 用户信息
     */
    const setLoginInfo = (data: WxLoginInfo_User) => {
      wxLoginInfo.value = data
      isLoggedIn.value = true

      // 保存用户token到localStorage
      if (data.accessToken) {
        localStorage.setItem('userToken', data.accessToken)
      }
    }
    /**
     * 设置用户信息
     * @param data 用户信息
     */
    const setUserInfo = (data: Myself) => {
      userInfo.value = data
    }

    /**
     * 用户登出
     */
    const logoutAction = () => {
      userInfo.value = null
      isLoggedIn.value = false
      localStorage.removeItem('userToken')
      localStorage.removeItem('searchParams')
    }

    /**
     * 初始化用户信息（从localStorage恢复）
     */
    const initUserInfo = () => {
      const token = localStorage.getItem('userToken')
      if (token && userInfo.value) {
        isLoggedIn.value = true
      }
    }

    /**
     * 更新用户注册步骤
     * @param step 注册步骤
     */
    const updateUserRegisterStep = (step: number) => {
      console.log('更新注册步骤:', step)
      // 这里可以保存到本地存储或发送到服务器
      localStorage.setItem('userRegisterStep', step.toString())
    }

    /**
     * 重置状态
     */
    const resetState = () => {
      userInfo.value = null
      isLoggedIn.value = false
    }

    return {
      // 状态
      userInfo,
      isLoggedIn,
      wxLoginInfo,
      userRegisterStep,
      // 动作
      getUserInfoAction,
      updateUserInfoAction,
      setUserInfo,
      logoutAction,
      initUserInfo,
      updateUserRegisterStep,
      resetState,
      setLoginInfo,
    }
  },
  {
    persist: true,
  }
)
